<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX1/8E0NNmzirPPosw+E12u6RgMJVfHgh5JA=","cpf":"U2FsdGVkX1/WHE6KTEbipQW41aRDywB8lcAp3GFoKfc="},{"num_cand":"U2FsdGVkX192JsuDaQaOHTGxsLB+exoCBZtSmGC0Vh0=","cpf":"U2FsdGVkX1+fwTpYm1m7iIQun1L18s6uI1R3Fgszjgg="},{"num_cand":"U2FsdGVkX18HY2cOL+B/GFNwPI5cqjEpqv/PsUO33Ks=","cpf":"U2FsdGVkX19wK+kE9+lGwGFI5GbzzWZAksWe+mmogPA="},{"num_cand":"U2FsdGVkX1/MVYtoc/NqQIX2+9mJC+142zdQ0TZgRPg=","cpf":"U2FsdGVkX1+/h+bfVvh1bxR0lRca+y5y/FnUZ5Rh9JA="},{"num_cand":"U2FsdGVkX19nL4VXbaRgFVsTIuz292xzknwWfKj9Fxs=","cpf":"U2FsdGVkX1+LBgNeN/iC0PeEEv54K59p9WyyNSE8Q08="},{"num_cand":"U2FsdGVkX1/sHN33BWwKg/9BoeMnj5nL4INEFiKjUtI=","cpf":"U2FsdGVkX1+DkkIA+2Fea2R7oXQ4G+sE2AaON9m5kIE="},{"num_cand":"U2FsdGVkX19ubL3qjUX87zFOePttnH0gh7g6ppOB+Zs=","cpf":"U2FsdGVkX1/dsH+vTMTPHIHFLUu9ZrH1Pf+3MjtCAGE="},{"num_cand":"U2FsdGVkX19GfCWT9mOMNGRSh0mYR5XVUDYXpnsEmPQ=","cpf":"U2FsdGVkX1+gk1wE1f8U/jRXeFbYxrixuqd+0p64r9U="},{"num_cand":"U2FsdGVkX1+d/HusGWxu0qSGE+3VcXA/eAgQ8aL2oSA=","cpf":"U2FsdGVkX1+MByDrbUEWz4IPAPFO7hj8Do3Vi/BZH0k="},{"num_cand":"U2FsdGVkX18HRGrszfxD6zMxma2YOaXJYL3IuQt3HTk=","cpf":"U2FsdGVkX19bOnxVFFxzkQy2sKenJhpu9kIuLqLTHsc="},{"num_cand":"U2FsdGVkX1/PPx4Z8+YgghHhEynKSBe67Ve9wxKCLPA=","cpf":"U2FsdGVkX1/DqetqKj9jE3KutZIDO0KnbtTwtOwq3o4="},{"num_cand":"U2FsdGVkX1+iGzOHo+8ni2d216wZydLXrz3q/KmnN5g=","cpf":"U2FsdGVkX19sHYE5ZODeJDpFWFnP0dfUflnaq2psOEQ="},{"num_cand":"U2FsdGVkX1+DyenfSs37E2i1yfrSqK6nlQkzzx0auj0=","cpf":"U2FsdGVkX181n7dxhDfGMeTpH4851ast6qmD20hr+O4="},{"num_cand":"U2FsdGVkX18Jsh0AL0uJoZWEJvy2PHeQjFOydU34ueE=","cpf":"U2FsdGVkX18fgpBrq2YbzHcS7bbkCffEjM53tFGOYmg="},{"num_cand":"U2FsdGVkX1/Eu1SRK7T5Gb8gjrrdb9yGtJOuA9oY+Aw=","cpf":"U2FsdGVkX1+/mH6qDsONZsLU/OMcCJ4TBMe0NObPpB0="},{"num_cand":"U2FsdGVkX19sk4tc2sqHxcv12nl7LqkRdgvJzSkfTE8=","cpf":"U2FsdGVkX1+8z3uZfKgpI149YDLot/veDzgqyv1UD6g="},{"num_cand":"U2FsdGVkX19PNoivjAomGVxy0u4C7CRVlGaN+JVfTZg=","cpf":"U2FsdGVkX1+YmVhSo2maGSyqBPFfXgsA9eL0Q4kFXeo="},{"num_cand":"U2FsdGVkX1+iCL64qr3K3fxlXl+5SHPxhTW6MQDIom0=","cpf":"U2FsdGVkX1/TOxv53WY0YWD0n4j71uBWnJJZdhl6kdo="},{"num_cand":"U2FsdGVkX18k66SZ7fLh3QUd/ijALGqEwyRkST2GBeI=","cpf":"U2FsdGVkX1+Be0PkXtJrNSltrPDxrNWnwqAQxI0DUiM="},{"num_cand":"U2FsdGVkX1/ZxgHADcRZv8XB8rm9NF1Z4/nLyrp9xJ0=","cpf":"U2FsdGVkX18OAiiDPDgAH87tfqLJ886sqPHKj+uLZHY="},{"num_cand":"U2FsdGVkX199aEwgc5LjQFpDQg4dVYbgAl/ZghO0l0o=","cpf":"U2FsdGVkX19TRQ/N/PC/ACBBSiYXkevsKZjB3IpaCzI="},{"num_cand":"U2FsdGVkX1+cTVNE0Tc61YYRs8XwehkQQVHyhzceoQs=","cpf":"U2FsdGVkX182LPVFNTFOcczFyVoMLRKmv1fT2oDu9bA="},{"num_cand":"U2FsdGVkX18ZLd/LIA4tn5DP6YYCrLk7sgWqNRkfSx4=","cpf":"U2FsdGVkX1+w+UMQP0gWyMg5UJ3IQqVTTp0+2TmWqLc="},{"num_cand":"U2FsdGVkX1/DDBciG43rKNnpdpelZiO5hNO3r6cx2mc=","cpf":"U2FsdGVkX1/uLN00Pbi7cbw1oUZEAg/nm1acWzUia4I="},{"num_cand":"U2FsdGVkX1834C7Cj9mrZBd7sxRKk70YzrDTZJ3QR7M=","cpf":"U2FsdGVkX188sIIbBCRPKSxHo0T5Fx0azhRxKB/pAcU="},{"num_cand":"U2FsdGVkX18k+NnwEQkeOMyxNfW9QbUSR+sW7r1P1iE=","cpf":"U2FsdGVkX1+7GK4XOIH5cyfj2fjiQ99eG8WRWHQ2W5k="},{"num_cand":"U2FsdGVkX1+kYmopKGxwpV0L2kScSNxgnA30a1YocWU=","cpf":"U2FsdGVkX1+4EEQDWTFjt6unSAiLE2oAHlUOq/+g8Cs="},{"num_cand":"U2FsdGVkX19TsDWlDxJs19PSNFy+yf4+So/oKwhBGJk=","cpf":"U2FsdGVkX1+MDsNr3n+x7MEZ6PwCHSClY1So7J90gmM="},{"num_cand":"U2FsdGVkX18U/+M60zv851m9aUEq/nuH3F/nDQzifD0=","cpf":"U2FsdGVkX1/yepwsvpURVfeCqKiE10fDy7JB/V1P8xY="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2203/rec_exame/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
